import { axios } from '../../../axios';

const addPropertyApi = (data) => {
  return axios.post('/properties/', data)
}
const updateProperty = (id, data) => {
  return axios.put(`/properties/${id}`, data)
}

export { addPropertyApi, updateProperty }